'use client'

import Image from 'next/image'
import React, { useEffect, useRef } from 'react'

const companies = [
  {
    name: 'Tarım ve Orman Bakanlığı',
    logo: '/assets/images/home/campaign/1.png',
    width: 288,
    height: 70,
  },
  {
    name: 'Nilüfer Belediyesi',
    logo: '/assets/images/home/campaign/2-light.png',
    width: 70,
    height: 70,
  },
  {
    name: 'Vakıflar Genel Müdürlüğü',
    logo: '/assets/images/home/campaign/3-light.png',
    width: 166,
    height: 70,
  },
  {
    name: 'Yıldırım Belediyesi',
    logo: '/assets/images/home/campaign/4.png',
    width: 118,
    height: 70,
  },
  {
    name: 'Bursa Valiliği',
    logo: '/assets/images/home/campaign/6.png',
    width: 70,
    height: 70,
  },
  {
    name: 'Mudanya Belediyesi',
    logo: '/assets/images/home/campaign/5.png',
    width: 70,
    height: 70,
  },
  {
    name: 'Osmangazi Belediyesi',
    logo: '/assets/images/home/campaign/7.png',
    width: 251,
    height: 70,
  },
  {
    name: 'Kültür Bakanlığı',
    logo: '/assets/images/home/campaign/8.png',
    width: 189,
    height: 70,
  },
  {
    name: 'Tarım ve Orman Bakanlığı',
    logo: '/assets/images/home/campaign/1.png',
    width: 288,
    height: 70,
  },
  {
    name: 'Nilüfer Belediyesi',
    logo: '/assets/images/home/campaign/2-light.png',
    width: 70,
    height: 70,
  },
  {
    name: 'Vakıflar Genel Müdürlüğü',
    logo: '/assets/images/home/campaign/3-light.png',
    width: 166,
    height: 70,
  },
  {
    name: 'Yıldırım Belediyesi',
    logo: '/assets/images/home/campaign/4.png',
    width: 118,
    height: 70,
  },
  {
    name: 'Bursa Valiliği',
    logo: '/assets/images/home/campaign/6.png',
    width: 70,
    height: 70,
  },
  {
    name: 'Mudanya Belediyesi',
    logo: '/assets/images/home/campaign/5.png',
    width: 70,
    height: 70,
  },
  {
    name: 'Osmangazi Belediyesi',
    logo: '/assets/images/home/campaign/7.png',
    width: 251,
    height: 70,
  },
  {
    name: 'Kültür Bakanlığı',
    logo: '/assets/images/home/campaign/8.png',
    width: 189,
    height: 70,
  },
]

export function Campaign() {
  const scrollerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const scroller = scrollerRef.current
    if (!scroller || scroller.hasAttribute('data-animated')) return

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      addAnimation(scroller)
    }

    function addAnimation(scroller: HTMLDivElement) {
      scroller.setAttribute('data-animated', 'true')
      const scrollerInner = scroller.querySelector(
        '.scrolling-content'
      ) as HTMLDivElement
      if (scrollerInner) {
        const scrollerContent = Array.from(
          scrollerInner.children
        ) as HTMLElement[]
        scrollerContent.forEach((item) => {
          const duplicatedItem = item.cloneNode(true) as HTMLElement
          duplicatedItem.setAttribute('aria-hidden', 'true')
          scrollerInner.appendChild(duplicatedItem)
        })
      }
    }
  }, [])

  return (
    <section id="campaign" className="overflow-y-hidden">
      <div ref={scrollerRef} className="scrolling-container">
        <div className="scrolling-content">
          {companies.map((company, index) => (
            <div key={index} className="message-wrapper mx-auto" aria-hidden>
              <Image
                src={company.logo}
                alt={company.name}
                width={company.width}
                height={company.height}
                loading="lazy"
                unoptimized
                style={{ height: company.height, width: company.width }}
                className="grayscale transition-all duration-300 hover:grayscale-0 "
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
